import { render, staticRenderFns } from "./MailViewer.vue?vue&type=template&id=37b59fdc&"
import script from "./MailViewer.vue?vue&type=script&lang=js&"
export * from "./MailViewer.vue?vue&type=script&lang=js&"
import style0 from "./MailViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports